import React, { Component } from 'react';
import cIf from 'classnames';
import acnt from 'accounting';

// Components
import { NumberSpinner } from '../../../../jsxctl/utilctl';

// Utils
import TranslateManager from 'ts-translate-js';
const tr = TranslateManager.boundTR;

interface PrepaidCardQtySelectionPriceRowProps {
    id: "HEADER" | "CUSTOM" | string;
    amount?: number;
    qty?: number;
    onChange?: (key: string, newAmount: number, newQty: number) => void;
}

export class PrepaidCardQtySelectionPriceRow extends Component<PrepaidCardQtySelectionPriceRowProps> {
    static readonly defaultProps: Partial<PrepaidCardQtySelectionPriceRowProps> = {
        amount: 0,
        qty: 0
    };

    constructor(props) {
        super(props);

        this.handleAmountChange = this.handleAmountChange.bind(this);
        this.handleQtyChange = this.handleQtyChange.bind(this);
        this.handleTextBoxClick = this.handleTextBoxClick.bind(this);
        this.handleItemClick = this.handleItemClick.bind(this);
    }

    handleQtyChange(newQty) {
        this.props.onChange(this.props.id, this.props.amount, newQty);
    }

    handleItemClick(e) {
        e.stopPropagation();
        e.preventDefault();
        if(this.props.qty === 0) // Clicking on an item only does something when the qty is zero...
            this.handleQtyChange(1); // And this, sets the qty to one...
        return false;
    }

    handleTextBoxClick(e) {
        e.stopPropagation();
    }

    handleAmountChange(e) {
        this.props.onChange(this.props.id, e.target.value, this.props.qty);
    }

    render() {
        let leftColContent;
        let rightColContent;

        if(this.props.id === "HEADER"){ // Not used anymore I think
            leftColContent = <span>{tr("Montants")}</span>;
            rightColContent = <span>{tr("Quantités")}</span>;
        } else {

            if(this.props.id === "CUSTOM") {
                const cSur = tsapp.getCurrencySurrounding();
                leftColContent =
                    <span>
                        <span>{tr("Montant personnalisé") + tr(":")} </span>
                        <span>{cSur.before}</span>
                        <input className="text-right" type="text" style={{width: "80px" }} value={this.props.amount} onClick={(e) => { e.stopPropagation(); e.preventDefault(); }} onChange={this.handleAmountChange} onFocus={(e) => e.target.select()} />
                        <span>{cSur.after}</span>
                    </span>;
            }
            else
                leftColContent = <h5>{acnt.formatMoney(this.props.amount)}</h5>;

            rightColContent = <NumberSpinner value={this.props.qty} min={0} max={10} onChange={this.handleQtyChange} onClick={this.handleTextBoxClick} />;


            // <input className="col-xs-12 text-center" type="text" onChange={this.handleQtyInputChange} onClick={this.handleTextBoxClick} onFocus={function(e) { e.target.select(); }} />;
        }

        const item =
            <div className="priceRow row">
                <div className="col-xs-6 col-sm-8 col-lg-8 text-center">{leftColContent}</div>
                <div className="col-xs-6 col-sm-4 col-lg-4 text-center">{rightColContent}</div>
            </div>;

        let ctl;
        if(this.props.id === "HEADER")
            ctl = <div key="header" className="list-group-item bg-default">{item}</div>;
        else
            //TODO: Refactor this as a button
            // eslint-disable-next-line sonarjs/anchor-is-valid
            ctl = <a
                        key={this.props.id} href="#"
                        onClick={this.handleItemClick}
                        className={cIf("list-group-item", { "active": this.props.qty > 0 && this.props.amount > 0 } )}>
                {item}
            </a>;

        return ctl;
    }
}


// PrepaidCardQtySelectionPriceRow.propTypes = {
//     id: PropTypes.oneOfType([ // This is the key of the row that the caller can use back to set the value in it's state
//         PropTypes.oneOf(["HEADER", "CUSTOM"]),
//         PropTypes.string
//     ]).isRequired,
//     amount: PropTypes.number,
//     qty: PropTypes.number,
//     onChange: PropTypes.func // f(key, newAmount, newQty)
// }

// PrepaidCardQtySelectionPriceRow.defaultProps = {
//     amount: 0,
//     qty: 0
// }